import React from "react";
import I18n from "i18n.js.erb";
import LineChart from "./LineChart";
import { CURRENCY_EURO } from "../../utils/utils";

const DOUGHNUT_OPTIONS = {
  plugins: {
    tooltip: { enabled: false },
    legend: { display: false },
    datalabels: { display: false }
  },
  cutout: '75%'
};

const DoughnutSection = ({ title, stats, chartId }) => {
  if (!stats) return null;

  return (
    <div className="loop-totem-stats__section d-block justify-content-center text-center align-items-start p-3 font-size-14px text-weight-500">
      {title}

      <div className="mt-2 mb-1 d-flex justify-content-center align-items-center text-center">
        <LineChart
          type="doughnut"
          datasets={stats.datasets}
          labels={stats.legend_labels}
          options={DOUGHNUT_OPTIONS}
          maxHeight="100px"
          id={chartId}
        />
      </div>

      <div className="d-flex justify-content-center flex-wrap mt-2">
        {stats.legend_labels.map((label, idx) => (
          <div key={label} className="d-flex justify-content-center align-items-center m-2">
            <div
              className="br-50px h-15px w-15px mr-1"
              style={{ backgroundColor: stats.legend_colors[idx] }}
            />
            <span>{label.toUpperCase()}{stats.show_currency ? CURRENCY_EURO : ''}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

// Mappa a pallini delle celle, riga per riga, come nell'index del backoffice
const CellsLayout = ({ layout }) => {
  if (!layout || layout.length === 0) return null;

  return (
    <div className="loop-totem-stats__section loop-totem-stats__section--layout">
      <div className="loop-totem-stats__layout">
        {layout.map((row, rowIdx) => (
          <div key={rowIdx} className="loop-totem-stats__layout-row">
            {row.map(([label, color], colIdx) => (
              <div
                key={colIdx}
                className="loop-totem-stats__layout-dot"
                title={label}
                style={{ backgroundColor: color }}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

const ExpoTotemAccordionStats = ({ stats, totemId, isOpen, onToggle }) => {
  if (!stats) return null;

  return (
    <div className="loop-totem-stats">
      <CellsLayout layout={stats.layout} />

      <DoughnutSection
        title="BRAND"
        stats={stats.brand}
        chartId={`totem_brand_${totemId}`}
      />

      <DoughnutSection
        title={I18n.t('js.loopDashboard.stats.priceDistribution').toUpperCase()}
        stats={stats.price}
        chartId={`totem_price_${totemId}`}
      />

      <DoughnutSection
        title={I18n.t('js.loopDashboard.stats.occupancy').toUpperCase()}
        stats={stats.occupancy}
        chartId={`totem_occupancy_${totemId}`}
      />

      <div className="loop-totem-stats__section loop-totem-stats__section--legend p-3">
        <div className="row align-items-end font-size-14px text-weight-500">
          <div className="col-6 col-sm-8 col-md-6 col-lg-8 col-xl-7 pb-1">
            {I18n.t('js.loopDashboard.stats.totalCells').toUpperCase()}
          </div>
          <div className="col-6 col-sm-4 col-md-6 col-lg-4 col-xl-5 pb-1">
            <b>{stats.cells_count}</b>
          </div>

          <div className="col-6 col-sm-8 col-md-6 col-lg-8 col-xl-7 py-1">
            {I18n.t('js.loopDashboard.stats.occupiedCells').toUpperCase()}
          </div>
          <div className="col-6 col-sm-4 col-md-6 col-lg-4 col-xl-5 py-1">
            <b>{stats.occupied_cells_count}</b>
          </div>

          <div className="col-6 col-sm-8 col-md-6 col-lg-8 col-xl-7 py-1">
            {I18n.t('js.loopDashboard.stats.emptyCells').toUpperCase()}
          </div>
          <div className="col-6 col-sm-4 col-md-6 col-lg-4 col-xl-5 py-1">
            <b>{stats.empty_cells_count}</b>
          </div>

          <div className="col-6 col-sm-8 col-md-6 col-lg-8 col-xl-7 pt-1">
            {I18n.t('js.loopDashboard.stats.errorCells').toUpperCase()}
          </div>
          <div className="col-6 col-sm-4 col-md-6 col-lg-4 col-xl-5 pt-1">
            <b>{stats.error_cells_count}</b>
          </div>
        </div>

        {/* Con un solo espositore le mensole restano sempre aperte, quindi niente apri/chiudi */}
        {onToggle && (
          <div
            className="d-flex justify-content-center align-items-center blue-label cursor-pointer mt-auto pt-3 font-size-14px text-weight-500"
            onClick={onToggle}
          >
            <i className={`fas fa-caret-${isOpen ? 'up' : 'down'} mr-2`} />
            {I18n.t(`js.loopDashboard.${isOpen ? 'closeShelves' : 'openShelves'}`).toUpperCase()}
            <i className={`fas fa-caret-${isOpen ? 'up' : 'down'} ml-2`} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ExpoTotemAccordionStats;
